module.exports = "/images/es-ce.svg?1244839dd320237f58c7d1583c7da0a1";